export default __webpack_public_path__ + "static/media/Q2_2.a54ad484.png";